/**
 * @fileoverview "Import CSV" action with Meta spend coverage, shown in the Meta entry of the ad platforms card.
 * @module features/ad-spends/components/import/MetaCsvImportAction
 */

import { useState, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { FileUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useMetaImportCoverage } from '../../hooks/useMetaCsvImport'
import { MetaCsvImportDialog } from './MetaCsvImportDialog'

export function MetaCsvImportAction(): ReactElement {
  const { t } = useTranslation('features-ad-spends')
  const [open, setOpen] = useState(false)
  const lastDate = useMetaImportCoverage().data?.lastDate

  return (
    // Clicks (including ones bubbling from the portal-rendered dialog) must not toggle the card entry.
    <div className="flex items-center justify-between gap-2 border-t border-border pt-2" onClick={e => e.stopPropagation()}>
      <span className="text-xs text-muted-foreground">
        {lastDate
          ? t('import.action.coverage', { defaultValue: 'Meta spend available through {{date}}', date: lastDate })
          : t('import.action.noCoverage', { defaultValue: 'No Meta spend stored yet' })}
      </span>
      <Button type="button" variant="outline" size="sm" className="shrink-0 gap-1.5" onClick={() => setOpen(true)}>
        <FileUp className="size-3.5" />
        {t('import.action.button', { defaultValue: 'Import CSV' })}
      </Button>
      <MetaCsvImportDialog open={open} onOpenChange={setOpen} />
    </div>
  )
}
